import { render, staticRenderFns } from "./MaxText.vue?vue&type=template&id=7d63394e&scoped=true"
import script from "./MaxText.vue?vue&type=script&lang=js"
export * from "./MaxText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d63394e",
  null
  
)

export default component.exports